import React, { lazy, Suspense } from "react";
import "./contact.css";
import Map from "../dynamic/Map";
import FetchContent from "../dynamic/fetchContent";
import ContactStripe from "./ContactInfoForm";
import useAuth from "../../hooks/useAuth.js";
import { useTranslation } from "react-i18next";
import Content from "../dynamic/Content";
import ImageContent from "../dynamic/ImageContent";

const FetchImage = lazy(() => import("../dynamic/fetchImage"));

export default function Contact() {
  const { auth, username } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="default">
      <Suspense fallback={<h1>Still Loading…</h1>}>
        {!auth?.role ? (
          <FetchImage title="contact-1" type="image-about" />
        ) : (
          <ImageContent
            title="contact-1"
            username={username}
            type="image-about"
          />
        )}
      </Suspense>
      <div className="stripe">
        <div className="contact-title">
          {" "}
          <h1>{t("contact_page.contact")}</h1>{" "}
        </div>

        <div className="stripe container about-us-main">
          <div className="about-us-main-img">
            {!auth?.role ? (
              <FetchImage title="contact" type="about-us-main-img-container" />
              ) : (
              <ImageContent
                title="contact"
                username={username}
                type="about-us-main-img-container"
              />
            )}
          </div>

          <div className="about-us-main-content">
            {!auth?.role ? (
              <div className="p-brandnew">
                <FetchContent title="p-contact" />
              </div>
            ) : (
              <div className="p-brandnew">
                <Content title={"p-contact"} styling="p" />
              </div>
            )}
          </div>
        </div>

        {/* <SimpleGrid
          cols={2}
          spacing="lg"
          breakpoints={[{ maxWidth: 1000, cols: 1, spacing: "sm" }]}
        >
          <div className="container-contact-profile">
            <Suspense fallback={<h1>Loading</h1>}>
              {!auth?.role ? (
                <FetchImage title="contact" type="image-contact" />
              ) : (
                <ImageContent
                  title="contact"
                  username={username}
                  type="image-contact"
                />
              )}
            </Suspense>
          </div>

          <div className="p container">
            {!auth?.role ? (
              <FetchContent title="p-contact" />
            ) : (
              <Content title={"p-contact"} styling="p" />
            )}
          </div>
        </SimpleGrid> */}
      </div>

      <div className="stripe stripe-contact">
        <div className="container-contact">
          <ContactStripe />
        </div>
      </div>
      <div className="contact-map">
        {!auth?.role ? <Map /> : <Map adminUser={true} />}
      </div>
    </div>
  );
}
